import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'
import { i18n } from '../plugins/i18n.js';

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})
Vue.use(VueSweetalert2);


const router = new VueRouter({
  base: '/caracterizacion360/',
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'hash',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar.
    NProgress.start()
  }

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
  const dependency = routeTo.meta.hasOwnProperty('dependency') ? routeTo.meta.dependency : null

  if (store.state.language.language && store.state.language.language !== i18n.locale) {
    i18n.locale = store.state.language.language;
    validateauth(authRequired, dependency, routeTo, next)
  }else if (!store.state.language.language) {
    store.dispatch('language/setLanguage', 
      { 
        currentLanguage: "es", //navigator.language, 
        languages: ["es", "en-US"] //navigator.languages,
      })
      .then(() => {
        i18n.locale = store.state.language.language;
        validateauth(authRequired, dependency, routeTo, next)
      });
  }else{
    validateauth(authRequired, dependency, routeTo, next)
  }

  if (!store.getters['appAuth/appLoggedIn']){
    store.dispatch('appAuth/appLogIn')
  }


  function validateauth(authRequired, dependency, routeTo, next) {
    // If auth isn't required for the route, just continue.
    if (!authRequired) return next()

    // If auth is required and the user is logged in...
    if (store.getters['auth/loggedIn']) {

      // Validate the local user token...
      return store.dispatch('auth/validate').then((validUser) => {
        // Then continue if the token still represents a valid user,

        if (validUser){
          // make route based validation (feb-9-2022 jmg)
          validatePermissionOnRoute(routeTo, '/home', next, dependency)
        } else {
          // otherwise redirect to login.
          redirectToLogin()
        } 
      })
    }
    redirectToLogin()
  }
  
  function redirectToLogin() {
    // Pass the original route to the login component
    next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
  }

  function getAllowedRoutes(routes, sections){
    sections.forEach(function(x){ 
      if(x.hasOwnProperty('children')){
        routes = getAllowedRoutes(routes, x.children)
      } else {
        if(x.path !== null){ routes.push(x.path) }
      }
    })
    return routes;
  }
  
  function validatePermissionOnRoute(targetRoute, defaultPath, next, dependency=null){
    const user_sections = store.state.auth.currentSession.user.app_sections_tree
    let routes = [];
    const path = dependency ? dependency : targetRoute.path
    routes = getAllowedRoutes(routes, user_sections)
    const currSession = store.getters['auth/currentSession']
    if (store.getters['auth/loggedIn'] && currSession && routes.includes(path) 
        || ['logout','home'].includes(targetRoute.name)){
      next();
    } else {
      Vue.prototype.$swal({
        title: 'Atención',
        html: 'No tienes permiso para ingresar a esta opción, verifica!',
        confirmButtonText: 'Aceptar',
        showCloseButton: true,
        width: '500px'
      });
      router.push(defaultPath);
    }
  }

})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              if (routeFrom.name === args[0].name) {
                // Complete the animation of the route progress bar.
                NProgress.done()
              }
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
